
import { Component, Prop, Vue } from "vue-property-decorator";
import methodList from "@/config/Common.ts";
import UdcBannerGeneric from "@/components/UdcBannerGeneric.vue";

@Component({
  name: "celebrus-hub-offres",
  components: {
    UdcBannerGeneric
  },
})

export default class CelebrusHubOffres extends Vue {
  @Prop() private banner!: any;
  private methods = methodList;
  private bannerHasChild;
  private bannerExtended = false;
  public hasChild = () => !!this.methods.getThisBanner(this.banner).querySelector(".celebrus-hub-offres-wrapper");
  public beforeMount() { this.bannerHasChild = this.hasChild(); }
  public mounted() {
    this.$el.addEventListener("click", () => this.methods.onCtaClick(this.banner) );
    if ( this.bannerHasChild ) {
      window.addEventListener("resize", this.sendTrackingOnVisible);
      document.addEventListener("scroll", this.sendTrackingOnVisible);
      this.sendTrackingOnVisible();
    }
  }

  private sendTrackingOnVisible() {
    const targetContainer = this.$el;
    const targetPosition = targetContainer.getBoundingClientRect();

    if ( targetContainer !== null && !this.bannerExtended ) {
      const containerStyle = window.getComputedStyle(targetContainer);
      const mostlyVisible = ( window.innerHeight - targetPosition.top) / targetPosition.height * 100 > 90 &&
                            ( targetPosition.top + targetPosition.height > targetPosition.height * 0.9 );
      const displayed =     containerStyle.visibility !== "hidden" && containerStyle.display !== "none";
      const parentVisible = !!(targetContainer as HTMLElement).offsetParent;

      if ( !mostlyVisible || !displayed || !parentVisible ) { return false; }

      // On enleve les évents et l'observateur pour éviter les doublons
      window.removeEventListener("resize", this.sendTrackingOnVisible);
      document.removeEventListener("scroll", this.sendTrackingOnVisible);
      if (this.banner.celebrusHelper) { this.banner.celebrusHelper.extended(); }
      this.bannerExtended = true;
    }
  }
}

